export enum AppConfigStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export interface CreateAppConfigRequest {
  name: string;
  value: string;
  appName: string;
  scope: AppConfigScope;
}

export interface UpdateAppConfigRequest {
  name: string;
  appName: string;
  value: string;
  status: AppConfigStatus;
}

export interface RemoteConfig {
  name: string;
  value: string;
  appName: string;
  status: AppConfigStatus;
  createdAt: Date;
  updatedAt: Date;
}

export enum AppConfigScope {
  CLIENT_ONLY = "CLIENT_ONLY",
  SERVER_ONLY = "SERVER_ONLY",
}
